/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.admin.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type GetMainAgentQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetMainAgentQuery = {
  __typename?: 'query_root';
  grove_agents: Array<{ __typename?: 'grove_agents'; id: string; unique_id: string }>;
};

export const GetMainAgentDocument = `
    query GetMainAgent {
  grove_agents(
    where: {parent_id: {_is_null: true}, retired_at: {_is_null: true}}
    limit: 1
  ) {
    id
    unique_id
  }
}
    ` as string & TypedDocumentNode<GetMainAgentQuery, GetMainAgentQueryVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    GetMainAgent: build.query<GetMainAgentQuery, GetMainAgentQueryVariables | void>({
      query: (variables) => ({ document: GetMainAgentDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useGetMainAgentQuery, useLazyGetMainAgentQuery } = injectedRtkApi;
